'use client';

import React from 'react';
import NextBreadcrumb from '../Breadcrumbs/NextBreadcrumb';

interface HeaderProps {
  variant?: 'default' | 'dark' | 'light';
  title?: string;
  description?: string;
  breadcrumbMap?: Record<string, string>;
  hiddenPaths?: string[];
  isIndustryView?: boolean;
  isCustomPath?:boolean;
}

export default function Header({
  variant = 'default',
  title,
  description,
  breadcrumbMap,
  hiddenPaths,
  isIndustryView,
  isCustomPath=false
}: HeaderProps) {
  return (
    <header className={`w-full mt-16 lg:pt-10 ${variant === 'dark' ? 'bg-dark01' : variant === 'light' ? 'bg-light01' : ''}`}>
      <div className="container lg:py-8">
        <NextBreadcrumb
          variant={variant}
          titleCustom={title}
          descriptionCustom={description}
          breadcrumbMap={breadcrumbMap}
          hiddenPaths={hiddenPaths}
          isIndustryView={isIndustryView}
          isCustomPath={isCustomPath}
        />
      </div>
    </header>
  );
}